<template>
  <b-modal
      :visible="show"
      @hidden="hideEvents"
      title="Add Work Order to Items"
      :id="modalId"
  >
    <vue-element-loading :active="loading" :is-full-screen="false"/>
    <b-form>
      <b-form-group
          label="Work Order"
      >
        <input type="text" v-model="value" class="form-control">
        <div class="flex flex-row">
          <span class="mt-2 pl-2">Note that this will overwrite any existing work orders for the actions selected.</span>
        </div>
      </b-form-group>
    </b-form>
    <template slot="modal-footer">
      <b-button
          variant="outline-secondary"
          @click="hideModal">
        Cancel
        <font-awesome-icon
            :icon="['far', 'times']">
        </font-awesome-icon>
      </b-button>
      <b-button
          class="btn-arrow"
          variant="primary"
          @click="bulkEditWorkOrder"
      >
        Add Work Order to Items
        <font-awesome-icon
            :icon="['far', 'arrow-right']">
        </font-awesome-icon>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {Vue} from "vue-property-decorator";
import {Component} from "vue-property-decorator";
import TagSelect from '@/components/Form/TagSelect.vue'
import ModalMixin from '@/components/Modal/ModalMixin'
import TextField from '@/components/Form/TextField.vue'
import Action from "@/services/Action/Action";
import * as types from "@/store/mutation-types";
import ClientAction from "@/services/Action/ClientAction";

export default {
  name: 'Work-Order-Modal',
  components: {
    TextField,
    TagSelect,
  },
  props: {
    nodeIds: {
      type: Array,
      default: () => [],
    },
    actionCount: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      required: true,
    },
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'workOrderModal',
      loading: false,
      value: '',
    };
  },
  methods: {
    async bulkEditWorkOrder() {
      if (this.nodeIds.length === 0) {
        return;
      }

      this.loading = true;

      const params = {
        action_ids: this.nodeIds,
        work_order: this.value,
      };
      await ClientAction.bulkUpdateWorkOrders(this.type, params)
        .then((response) => {
          this.$notify({
            title: 'Success',
            text: `Work Order updated for ${this.nodeIds.length} actions.`,
            type: 'success',
          });
        })
        .catch((e) => {
          this.$notify({
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            type: 'error',
          });
        });
      this.$store.dispatch('refreshActions');
      this.hideModal();
    },

    hideModalEvents() {
      this.value = '';
    },
  },
};
</script>

<style lang="scss">
.modal {
  .btn.btn-arrow {
    min-width: 140px;
  }

  .btn-outline-secondary + .btn-arrow {
    margin: auto;
    margin-right: 0;
  }
}
</style>